// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rkloYmkOLm8dCZ9fMhY0{flex-direction:column;gap:12px;display:flex}.GmTDjCQh96QPKDK0XT5u{align-items:center;gap:8px;display:flex}.rkloYmkOLm8dCZ9fMhY0 .GmTDjCQh96QPKDK0XT5u .MabQe6O8sM_HcVV2GOri{margin-left:auto;padding-top:2.5px;padding-bottom:2.5px}.lgFOG_g7g6ouYAHCWoWc{border-radius:4px;width:12px;height:12px}.HV9BCbA0xZYU0tf56At3{background:var(--green-60)}.XnKDaIVZonoOLrGXPKrM{background:var(--yellow-70)}.bvGBgAI4UwEvTEUHM6D5{background:var(--red-80)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"category": `rkloYmkOLm8dCZ9fMhY0`,
	"categoryLabel": `GmTDjCQh96QPKDK0XT5u`,
	"categoryRevert": `MabQe6O8sM_HcVV2GOri`,
	"dot": `lgFOG_g7g6ouYAHCWoWc`,
	"dot_green": `HV9BCbA0xZYU0tf56At3`,
	"dotGreen": `HV9BCbA0xZYU0tf56At3`,
	"dot_orange": `XnKDaIVZonoOLrGXPKrM`,
	"dotOrange": `XnKDaIVZonoOLrGXPKrM`,
	"dot_red": `bvGBgAI4UwEvTEUHM6D5`,
	"dotRed": `bvGBgAI4UwEvTEUHM6D5`
};
export default ___CSS_LOADER_EXPORT___;
